import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

export const SelectCss = `
  width: 100%;
  border: ${css.inputBorder};
  border-radius: ${css.inputBorderRadius};
  background: ${css.inputBackgroundColor};
  color: ${css.grey2};
  padding: 0 0.75rem;
  height: 3rem;
  min-height: ${css.inputHeight};
  box-sizing: border-box;
  font-size: 1rem;
  font-family: ${css.fontFamily};
  &::placeholder {
    text-transform: capitalize;
  }
  &:disabled {
    background-color: ${css.grey8};
    cursor: not-allowed;
    appearance: none;
  }
  &:focus {
    outline: none;
  }
`;

const SelectStyled = styled.select`
  ${SelectCss};
`;

export interface SelectProps {
  id?: string;
  className?: string;
  placeholder?: string;
  value?: string;
  defaultValue?: string;
  options: { value: any, label: string, disabled?: boolean }[];
  onChange?(value: string, e: React.ChangeEvent<HTMLSelectElement>): void;
  disabled?: boolean;
}

/** Styled native select dropdown. */
export const Select = (props: SelectProps) => {
  return (
    <SelectStyled
      id={props.id}
      className={props.className}
      value={props.value}
      defaultValue={props.defaultValue}
      onChange={(e) => props.onChange?.(e.target.value, e)}
      disabled={props.disabled}
    >
      {
        props.options.map((option) => {
          return (
            <option key={option.value} value={option.value} disabled={option.disabled}>{option.label}</option>
          );
        })
      }
    </SelectStyled>
  );
};